"use client";

import { motion } from "framer-motion";

import styles from "./FifaOutroSection.module.scss";

export default function FifaOutroSection() {
  return (
    <section className={styles.section}>
      <div className={styles.overlay} />

      <motion.div
        className={styles.content}
        initial={{
          opacity: 0,
          y: 60,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        viewport={{
          once: true,
          amount: 0.3,
        }}
        transition={{
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1],
        }}
      >
        <p
          className={styles.description}
          
        >
          Through football, Kia connects with fans around the
          world, sharing emotion and inspiration.
          <br />
          Believing in the true power of inspiration
          that sport delivers, Kia moves forward—toward
          sustainability and innovation.
        </p>

        <p
          className={styles.highlight}
        >
          Beyond the game, Kia brings greater possibilities
          and lasting value to the world.
        </p>
      </motion.div>
    </section>
  );
}